import React from 'react'
import { Route } from 'react-router-dom'

import BaseLayout from '../../common/components/BaseLayout'
import Sidebar from '../../admin/components/Sidebar'

import Permissions from '../../admin/permissions/components/Index'
import Roles from '../../admin/roles/components/Index'
import IncidentTypes from '../../admin/incidentTypes/components/Index'
import IncidentCategories from '../../admin/incidentCategories/components/Index'
import IncidentDivisions from '../../admin/incidentDivisions/components/Index'
import Overlays from '../../admin/overlays/components/Index'
import AILayers from '../../admin/aiLayers/components/Index'
import SigEventsIncidents from '../../admin/sigevents/incidents/components/Index'
import Users from '../../admin/users/components/Index'
import Buffers from '../../admin/buffers/components/Index'

import styles from './MainLayout.module.css'

const MainLayout = () => {
  return (
    <BaseLayout title="Admin">
      <Sidebar />
      <div className={styles.body}>
        <Route path="/admin/permissions" component={Permissions} />
        <Route path="/admin/roles" component={Roles} />
        <Route path="/admin/incidentTypes" component={IncidentTypes} />
        <Route
          path="/admin/incidentCategories"
          component={IncidentCategories}
        />
        <Route path="/admin/incidentDivisions" component={IncidentDivisions} />
        <Route path="/admin/overlays" component={Overlays} />
        <Route path="/admin/aiLayers" component={AILayers} />
        <Route
          path="/admin/sigevents/incidents"
          component={SigEventsIncidents}
        />
        <Route path="/admin/users/" component={Users} />
        <Route path="/admin/buffers/" component={Buffers} />
      </div>
    </BaseLayout>
  )
}

export default MainLayout
